var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{attrs:{"id":"count-to"}},[_c('em',{staticClass:"prefix"},[_vm._v(_vm._s(_vm.prefix))]),_vm._v(" "),_c('b',{staticClass:"count-val"},[_vm._v(_vm._s(_vm.displayValue))]),_vm._v(" "),_c('em',{staticClass:"suffix"},[_vm._v(_vm._s(_vm.suffix))])])
}
var staticRenderFns = []

export { render, staticRenderFns }